import { EpimsBaseEntityDto } from './epim-base.dto';
export class LeagueDto extends EpimsBaseEntityDto {

    LeagueId: string;

    LeagueName: string;

    CountryId: string;

  

}